var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonSocialActivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -2646.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Social-activity",
    transform: "translate(1206.000000, 2646.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.275,16.397 C24.018,16.796 23.329,17.61 22.992,17.952 L16.611,24.337 C16.27,24.674 15.718,24.674 15.383,24.337 L8.754,17.71 C8.417,17.37 7.944,16.754 7.689,16.351 C7.689,16.351 7,15.244 7,14.09 C7,11.605 9.013,9.59 11.497,9.59 C13.982,9.59 16,11.605 16,14.09 C16,11.605 18.013,9.59 20.5,9.59 C22.986,9.59 25,11.605 25,14.09 C25,15.261 24.275,16.397 24.275,16.397 M16,0 C7.163,0 0,7.163 0,16 C0,24.836 7.163,32 16,32 C24.837,32 32,24.836 32,16 C32,7.163 24.837,0 16,0",
    id: 189
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonSocialActivity);
export default __webpack_public_path__ + "static/media/common-social-activity.ba54912d.svg";
export { ForwardRef as ReactComponent };